import styled from "styled-components";

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.5rem;
  font-family: "Silkscreen", monospace;
  font-size: 0.62rem;
  text-transform: uppercase;
  user-select: none;
  touch-action: none;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`;

export const IconButton = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  font-family: inherit;
  font-size: 0.85rem;
  line-height: 1;
  padding: 0 0.2rem;
`;

export const FloatingWrap = styled.div`
  position: fixed;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
`;

export const FloatingBody = styled.div`
  overflow: auto;
  max-height: calc(80vh - 1.75rem);
`;
